import { render, staticRenderFns } from "./Bio.vue?vue&type=template&id=2d5eab3d&"
import script from "./Bio.vue?vue&type=script&lang=js&"
export * from "./Bio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports